/* tslint:disable */

/**
 */
export class NotifyReadForm {
    id?: number;
    readed?: number;
}
